export enum TrackingEvent {
  FetchMetricData = `Fetch metric data`,
}
